import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'
import type { SentimentFilter } from '../model/contracts'

const VALID: ReadonlySet<SentimentFilter> = new Set(['positive', 'neutral', 'negative'])

function parseParam(raw: string): SentimentFilter[] {
  if (!raw) return []
  return raw
    .split(',')
    .filter((v): v is SentimentFilter => VALID.has(v as SentimentFilter))
}

export function useSentimentFilter(): {
  sentimentFilter: SentimentFilter[]
  setSentimentFilter: (next: SentimentFilter[]) => void
} {
  const [searchParams, setSearchParams] = useSearchParams()

  const sentimentFilter = parseParam(searchParams.get('sentiment') ?? '')

  const setSentimentFilter = useCallback(
    (next: SentimentFilter[]) => {
      setSearchParams(
        (prev) => {
          const updated = new URLSearchParams(prev)
          if (next.length === 0) {
            updated.delete('sentiment')
          } else {
            updated.set('sentiment', next.join(','))
          }
          return updated
        },
        { replace: true },
      )
    },
    [setSearchParams],
  )

  return { sentimentFilter, setSentimentFilter }
}
